import { AsciiText } from '../framework/AsciiText';
import { NanolumensCaptivateBase } from './util/NanolumensCaptivateBase';
export class NanolumensCaptivateTcp extends NanolumensCaptivateBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
    }
    send(bytes) {
        this.socket.send(AsciiText.decode(bytes));
    }
}
NanolumensCaptivateTcp.emulatorType = 'socketEmulator';
NanolumensCaptivateTcp.key = '-O3n3lvRiFMGscsNsuWp';
